/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_OtherInputs */

const en_admin_questionnaire_editor_other = /** @type {(inputs: Admin_Questionnaire_Editor_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const nl_admin_questionnaire_editor_other = /** @type {(inputs: Admin_Questionnaire_Editor_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overig`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_OtherInputs) => LocalizedString} */
const de_admin_questionnaire_editor_other = en_admin_questionnaire_editor_other;

/** @type {(inputs: Admin_Questionnaire_Editor_OtherInputs) => LocalizedString} */
const es_admin_questionnaire_editor_other = en_admin_questionnaire_editor_other;

/** @type {(inputs: Admin_Questionnaire_Editor_OtherInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_other = en_admin_questionnaire_editor_other;

/** @type {(inputs: Admin_Questionnaire_Editor_OtherInputs) => LocalizedString} */
const it_admin_questionnaire_editor_other = en_admin_questionnaire_editor_other;

/** @type {(inputs: Admin_Questionnaire_Editor_OtherInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_other = en_admin_questionnaire_editor_other;

/** @type {(inputs: Admin_Questionnaire_Editor_OtherInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_other = en_admin_questionnaire_editor_other;

/** @type {(inputs: Admin_Questionnaire_Editor_OtherInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_other = en_admin_questionnaire_editor_other;

/** @type {(inputs: Admin_Questionnaire_Editor_OtherInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_other = en_admin_questionnaire_editor_other;

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Admin_Questionnaire_Editor_OtherInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_other = /** @type {((inputs?: Admin_Questionnaire_Editor_OtherInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_OtherInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_other(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_other(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_other(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_other(inputs)
	if (locale === "nl") return nl_admin_questionnaire_editor_other(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_other(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_other(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_other(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_other(inputs)
	return ro_admin_questionnaire_editor_other(inputs)
});
export { admin_questionnaire_editor_other as "admin.questionnaire_editor.other" }